
// Optional displayName matches the Engineering Book's provider label when it differs
// from name, which existing drive configuration screens continue to use.
export const ConnectionTypes = {
  sftp: {
    name: 'SSH (SFTP)',
    displayName: 'SFTP',
    portPlaceholder: '22',
    brandingIcon: '/app/assets/images/branding/sftp/sftp.svg',
    branding: '/app/assets/images/branding/sftp/sftp.svg',
    protocol: 'sftp',
  },
  ftp: {
    name: 'FTP',
    portPlaceholder: '21',
    brandingIcon: '/app/assets/images/branding/ftp/ftp.svg',
    branding: '/app/assets/images/branding/ftp/ftp.svg',
  },
  s3: {
    name: 'Amazon S3',
    defaultServer: 's3.amazonaws.com',
    defaultNickname: 'Amazon S3',
    brandingIcon: '/app/assets/images/branding/s3/s3.svg',
    branding: '/app/assets/images/branding/s3/s3.svg',
    sharedLinks: true,
    protocol: 's3',
    versions: true,
    defaultStsEndpoint: 'sts.amazonaws.com',
  },
  s3iam: {
    name: 'Amazon S3 with IAM Role',
    defaultServer: 's3.amazonaws.com',
    defaultNickname: 'Amazon S3',
    brandingIcon: '/app/assets/images/branding/s3/s3.svg',
    branding: '/app/assets/images/branding/s3/s3.svg',
    sharedLinks: true,
    protocol: 's3',
    versions: true,
    defaultStsEndpoint: 'sts.amazonaws.com',

  },
  webdav: {
    name: 'WebDAV',
    serverPlaceholder: 'https://yourserver.com/dav',
    brandingIcon: '/app/assets/images/branding/webdav/webdav.svg',
    branding: '/app/assets/images/branding/webdav/webdav.svg',
  },
  nextcloud: {
    name: 'Nextcloud',
    defaultNickname: 'Nextcloud',
    serverPlaceholder: 'https://cloud.example.com',
    brandingIcon: '/app/assets/images/branding/nextcloud/icon80.png',
    branding: '/app/assets/images/branding/nextcloud/header400.png',
    protocol: 'webdav',
    defaultRemotePath: '/remote.php/webdav',
  },
  wasabi: {
    name: 'Wasabi',
    defaultNickname: 'Wasabi',
    defaultServer: 's3.wasabisys.com',
    brandingIcon: '/app/assets/images/branding/wasabi/wasabi.svg',
    branding: '/app/assets/images/branding/wasabi/wasabi.svg',
    protocol: 's3',
  },
  box: {
    name: 'Box.com',
    displayName: 'Box',
    server: 'Box.com',
    defaultNickname: 'Box',
    brandingIcon: '/app/assets/images/branding/box/box.svg',
    branding: '/app/assets/images/branding/box/box.svg',
    protocol: 'box',
    oauth: true,
    sharedLinks: true,
    search: true,
  },
  dropbox: {
    name: 'Dropbox',
    server: 'dropbox.com',
    defaultNickname: 'Dropbox',
    brandingIcon: '/app/assets/images/branding/dropbox/dropbox.svg',
    branding: '/app/assets/images/branding/dropbox/dropbox.svg',
    protocol: 'dropbox',
    oauth: true,
    search: true,
    sharedLinks: true,
    versions: true,
  },
  // Device telemetry reports this provider as "e2"; deviceTelemetry resolves the alias.
  idrivee2: {
    name: 'IDrive e2',
    defaultNickname: 'IDrive e2',
    brandingIcon: '/app/assets/images/branding/e2/e2.png',
    branding: '/app/assets/images/branding/e2/e2.png',
    protocol: 's3',
  },
  gdrive: {
    name: 'Google Drive',
    server: 'googledrive.com',
    defaultNickname: 'Google Drive',
    brandingIcon: '/app/assets/images/branding/gdrive/gdrive.svg',
    branding: '/app/assets/images/branding/gdrive/gdrive.svg',
    protocol: 'gdrive',
    oauth: true,
    sharedLinks: true,
    search: true,
    versions: true,
  },
  gcloud: {
    name: 'Google Cloud Storage',
    defaultNickname: 'Google Storage',
    brandingIcon: '/app/assets/images/branding/gcloud/gcloud.svg',
    branding: '/app/assets/images/branding/gcloud/gcloud.svg',
    protocol: 'gcloud',
    oauth: true,
  },
  onedrive: {
    name: 'OneDrive',
    server: 'onedrive.live.com',
    defaultNickname: 'OneDrive',
    brandingIcon: '/app/assets/images/branding/onedrive/onedrive.svg',
    branding: '/app/assets/images/branding/onedrive/onedrive.svg',
    protocol: 'onedrive',
    oauth: true,
    sharedLinks: true,
    search: true,
    versions: true,
  },
  onedrivebusiness: {
    name: 'OneDrive for Business',
    defaultNickname: 'OneDrive Business',
    server: 'ondrive.live.com',
    brandingIcon: '/app/assets/images/branding/onedrive/onedrive.svg',
    branding: '/app/assets/images/branding/onedrive/onedrive.svg',
    protocol: 'onedrivebusiness',
    oauth: true,
    sharedLinks: true,
    search: true,
    versions: true,
  },
  sharepoint: {
    name: 'Sharepoint Online',
    displayName: 'SharePoint',
    defaultNickname: 'Sharepoint',
    server: 'sharepoint.com',
    brandingIcon: '/app/assets/images/branding/sharepoint/sharepoint.png',
    branding: '/app/assets/images/branding/sharepoint/sharepoint.png',
    protocol: 'sharepoint',
    oauth: true,
    sharedLinks: true,
    search: true,
    versions: true,

  },
  b2: {
    name: 'Backblaze B2',
    server: 'backblaze.com',
    hideServer: true,
    defaultNickname: 'B2',
    brandingIcon: '/app/assets/images/branding/b2/b2.svg',
    branding: '/app/assets/images/branding/b2/b2.svg',
    protocol: 'b2',
    oauth: false,
    rename: false,
  },
}
